import * as organization from "./organizationAction";

const exporterObj = {
	...organization
};

export default exporterObj;
